import React, { useState, useEffect } from "react";
import "../Styles/Home.css";
import image1 from "../Assets/teach1.jpg";
import image2 from "../Assets/teach2.jpg";
import image3 from "../Assets/teach3.JPG";
import HomeImg from "../Assets/BackgroundImg.png";
const images = [image1, image2, image3];

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-change image every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // 4 seconds
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <><div className="home-banner">
        <img src={HomeImg} alt="Home Banner" className="home-img" />
        <button className="home-btn" onClick={() => window.open('https://gainwisdom.in/', '_blank')}>Start Learning</button>
      </div>
    <div className="home-container" id="#home">
      <div className="home-left">
        <h1>
          Gain Wisdom, Expand Knowledge
          <br />
          Through Quizzes, Videos & Audio-Based Learning.
        </h1>
        <p>
          Learning with "Gain Wisdom" is a new way of broadening your knowledge
          and enhancing your skills in a variety of ways, from engaging video
          lectures, audio contents, quizzes of various interesting forms of fill
          ups, drag and drop, multiple choice questions with explanatory answers,
          match up with instant scores. Unlimited attempts with shuffled
          questions and answers for practice until you get it perfect!!!
          A perfect learning tool anywhere anytime at your convenience.
        </p>
        <div className="button-group">
          <a href="#courses" className="btn-outline">
            ↓ Know more
          </a>
          <a
            href="mailto: info@gainwissdom.in"
            className="btn-filled"
            target="_blank"
            rel="noopener noreferrer"
          >
            Connect with me
          </a>
        </div>
      </div>

      <div className="home-right">
        <div className="slider-container">
          <button className="nav-button left" onClick={handlePrev}>
            &#60;
          </button>
          <img
            src={images[currentIndex]}
            alt={`Slide ${currentIndex + 1}`}
            className="slider-image"
          />
          <button className="nav-button right" onClick={handleNext}>
            &#62;
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default Home;
